import { Dispatch } from 'redux'
import {
  add as addAction,
  deletePost as deletePostAction,
  set as setAction,
  setLoading,
  update as updateAction
} from 'states/dux/nivos-post/actions'
import { Payload } from 'states/dux/nivos-post/types'
import { Action } from 'states/types'
import NivosPost from 'types/nivos-post'

type DispatchAction = (dispatch: Dispatch) => Action<Payload>

const set = (posts: NivosPost[]): DispatchAction => {
  return (dispatch: Dispatch): Action<Payload> =>
    dispatch(
      setAction({
        loading: false,
        data: posts
      })
    )
}

const update = (post: NivosPost): DispatchAction => {
  return (dispatch: Dispatch): Action<Payload> =>
    dispatch(
      updateAction({
        loading: false,
        data: [post]
      })
    )
}

const add = (post: NivosPost): DispatchAction => {
  return (dispatch: Dispatch): Action<Payload> =>
    dispatch(
      addAction({
        loading: false,
        data: [post]
      })
    )
}

const deletePost = (post: NivosPost): DispatchAction => {
  return (dispatch: Dispatch): Action<Payload> =>
    dispatch(
      deletePostAction({
        loading: false,
        data: [post]
      })
    )
}

const loading = (loading = true): DispatchAction => {
  return (dispatch: Dispatch): Action<Payload> => dispatch(setLoading(loading))
}

export interface Operations {
  set: (posts: NivosPost[]) => DispatchAction
  add: (post: NivosPost) => DispatchAction
  deletePost: (post: NivosPost) => DispatchAction
  update: (post: NivosPost) => DispatchAction
  loading: (loading: boolean) => DispatchAction
}

const operations: Operations = {
  set,
  add,
  deletePost,
  update,
  loading
}

export { operations, set }
